import { render, staticRenderFns } from "./BankAccountDeleteProvider.vue?vue&type=template&id=9effb71c&scoped=true&"
import script from "./BankAccountDeleteProvider.vue?vue&type=script&lang=ts&"
export * from "./BankAccountDeleteProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9effb71c",
  null
  
)

export default component.exports